export const BARE_ITEM = 'Bare Item';
//# sourceMappingURL=BARE_ITEM.js.map